import { IBaseProps } from './../../types/data';

export interface IOYSearchProps extends IBaseProps {
  /**
   * 组件宽度
   */
  width?: number;
  /**
   * 输入框宽度
   */
  inputWidth?: number;
  /**
   * 输入最大长度
   */
  maxlength?: number;
  /**
   * 数据
   */
  dataSource: IOYSearchDataSource[];
  /**
   * 热门搜索
   */
  hotSearch?: string[];
  /**
   * 热门搜索颜色。如果是数组的化。会按顺序循环取色
   */
  hotSearchColor?: string[];
  /**
   * datalist中options最多显示个数
   */
  maxDataListLength?: number;

  /**
  * 监听拦截datalist点击事件
  * 返回false可以拦截onDatalistClick事件触发
  *
  * @param [IRemoteData] data 完整数据
  * @memberof IOYSearchProps
  */
  beforeDatalistClick?: (data: IRemoteData) => void | boolean | Promise<boolean | void>
  /**
   * 监听拦截处理联想类目点击事件
   * 返回false可以拦截onAutoCompleteClick事件触发
   *
   * @param [IRemoteData] data 完整数据
   * @memberof IOYSearchProps
   */
  beforeAutoCompleteClick?: (data: IRemoteData) => void | boolean | Promise<boolean | void>;
  /**
   * tab点击切换事件
   */
  onTabChange?: (item: IOYSearchDataSource, index: number) => void;
  /**
   * 点击搜索按钮
   */
  onSuffixClick?: (value: ISearchSuffix, index: number) => void;
  /**
   * 点击热门搜索
   */
  onHotSearchClick?: (value: string) => void;
  /**
   * input框focus事件
   */
  onFocus?: (event: InputEvent) => void;
  /**
   * input框blur事件
   */
  onBlur?: (event: Event) => void;
  /**
   * 点击搜索事件
   */
  onSearch?: (data: { dataSourceId: any; suffixId: any, value: string }) => void;
  /**
   * 点击最近搜索item事件
   */
  onDatalistClick?: (data: { value: string; dataSourceId: any; }) => void;
  /**
   * 自动补全点击事件
   */
  onAutoCompleteClick?: (data: { value: string; dataSourceId: any; }) => void;
}

export interface IOYSearchDataSource {
  /**
   * id
   */
  id: string;
  /**
   * tab名称
   */
  name: string;
  /**
   * placeholder
   */
  placeholder?: string;
  /**
   * 初始值
   */
  defaultValue?: string;
  /**
   * 后缀按钮配置
   */
  suffix?: ISearchSuffix[];
  /**
   * 下拉框配置
   * @description 当输入内容为空时显示的内容
   */
  datalist?: IOYSearchDatalist[];
  /**
   * 远程搜索自动补全
   */
  atuoComplete?: IOYSearchAtuoComplete;
  /**
   * 远程搜索猜你想找
   */
  //  atuoGuessComplete?: IOYSearchAtuoGuessComplete;
}

export interface IOYSearchDatalist {
  /**
   * 分组标题
   */
  title: string;
  /**
   * 内容
   */
  options: IRemoteData[]
}

export interface IOYSearchAtuoComplete {
  /**
   * 延迟触发时间间隔
   */
  delay?: number;
  /**
   *  远程搜索方法。
   * @param key 搜索值
   * @param response 响应回调函数
   */
  // remote?: (key: string, response: (data: IRemoteData[]) => void) => void;
  remote?: (key: string, response: (data: IRemoteDataObj) => void) => void;
}

// export interface IOYSearchAtuoGuessComplete {
//   /**
//    * 延迟触发时间间隔
//    */
//   delay?: number;
//   /**
//    *  远程搜索方法。
//    * @param key 搜索值
//    * @param response 响应回调函数
//    */
//   remote?: (key: string, response: (data: IRemoteGuessData[]) => void) => void;
// }

export interface ISearchSuffix {
  /**
   * id
   */
  id: string;
  /**
   * 文本标签
   */
  label: string;
}

export interface ISearchState {
  current: number;
  inputValue: string[];
  inputWidth: number;
  defaultPlaceholder: string;
}

export interface IRemoteDataObj {
  associationList: IRemoteData[];
  guessFindData: IRemoteGuessData[]
}

export interface IRemoteData {
  code: null | string;
  logo: null | string;
  name: string;
  type: ERemoteType;
  typeName: string;
  url: null | string;
}

export interface IRemoteGuessData {
  corpusCotent: null | string;
  remark: string;
  id: null | string;
  count: null | number;
}

export enum ERemoteType {
  /** 没有类型 */
  None = -1,
  /** 店铺 */
  Shop = 1,
  /** 品种 */
  ShopSign = 4
}



// WEBPACK FOOTER //
// ./src/components/OYSearch/const.ts